import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ErrorService } from '../errorbar/error.service';
import { WsService } from '../ws/ws.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  private stateSubscription: Subscription;
  private workmodeSubscription: Subscription;
  private workmodeAnswerSubscription: Subscription;
  private connectSubscription: Subscription;
  public state: any;
  public user: any;
  public workmode: any;
  public ST: any;
  public WM: any;
  public waiting: boolean;
  public workmodeLocked: boolean;

  constructor(private ws: WsService, private error: ErrorService) {
      this.ST = this.ws.ST;
      this.WM = this.ws.WM;
      this.stateSubscription = this.ws.onState.subscribe(this.onChangeState.bind(this));
      this.workmodeSubscription = this.ws.onWorkMode.subscribe(this.onChangeWorkMode.bind(this));
      this.workmodeAnswerSubscription = this.ws.events.test_mode.subscribe(this.onAnswerWorkMode.bind(this))
      this.connectSubscription = this.ws.onConnect.subscribe(this.onConnect.bind(this));
      this.state = this.ws.getState();
      this.user = this.ws.getUser();
      this.workmode = this.ws.getWorkMode();
      this.waiting = false;
      this.workmodeLocked = false;
  }

  private onChangeState(state: number): void {
      this.state = state;
      this.user = this.ws.getUser();
      this.waiting = false;
  };

  private onChangeWorkMode(mode: string): void {
      this.workmode = mode;
      this.workmodeLocked = false;
  };

  private onAnswerWorkMode(): void {
      this.workmodeLocked = false;
  };

  private onConnect(): void {
      this.waiting = false;
      this.workmodeLocked = false;
  };

  public submitLogout() {
      if (!this.waiting) {
          this.waiting = true;
          this.ws.methodLogout();
      }
  };

  public setPause(pauseState: boolean): void {
      this.ws.methodPause(pauseState);
  };

  public toggleWorkMode(): void {
      if (!this.workmodeLocked) {
          this.workmodeLocked = true;
          this.ws.methodWorkMode();
      }
  };

  ngOnInit() {
  };

  ngOnDestroy() {
      this.stateSubscription.unsubscribe();
      this.workmodeSubscription.unsubscribe();
      this.connectSubscription.unsubscribe();
  };




  /// REMOVE
  public setState__debug(state: number): void {
      this.ws.setState(state);
  };
  public setCall__debug(reason: number): void {
      this.ws.methodDebugState({state: 7, id_call_reason: reason});
  };


}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts